module.exports = __webpack_public_path__ + "static/media/shoe (18).3bbfe828.jpg";